import React from 'react';
import sobreImg from '../../../assets/CasadoPandeiro_sobre.jpeg';
import clariceImg from '../../../assets/CasadoPandeiro_ClariceMagalhaes.jpeg';

export const SobrePage: React.FC = () => {
  return (
    <div>
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${sobreImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        role="img"
        aria-label="Roda de pandeiro na Casa do Pandeiro"
      >
        <div className="container py-40 md:py-56" />
      </div>

      <div className="container pt-4 pb-2 md:pt-6 md:pb-4 max-w-3xl mx-auto">
        <h1 className="text-2xl md:text-4xl font-bold text-primary">Sobre a Casa do Pandeiro</h1>
      </div>

      <div className="container py-6 md:py-10 max-w-3xl mx-auto">
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>
            A Casa do Pandeiro nasceu do desejo de criar um espaço inteiramente dedicado ao pandeiro,
            um dos instrumentos mais presentes e versáteis da música brasileira.
          </p>
          <p>
            Nosso objetivo é reunir profissionais, estudantes, curiosos e amantes da cultura brasileira em um
            ambiente que celebra a riqueza do pandeiro, criando conexões e oportunidades aos agentes culturais
            e à comunidade envolvida.
          </p>
        </div>

        {/* Fundadora */}
        <div className="mt-12 p-8 bg-secondary/60 rounded-lg border flex flex-col sm:flex-row gap-8 max-w-[90%] mx-auto">
          <img
            src={clariceImg}
            alt="Clarice Magalhães com pandeiro"
            className="w-full sm:w-48 h-64 object-cover rounded-lg flex-shrink-0"
          />
          <div>
            <h2 className="text-2xl text-primary mb-2">Clarice Magalhães</h2>
            <p className="text-sm text-accent font-medium mb-4">Fundadora da Casa do Pandeiro</p>
            <div className="space-y-3 text-muted-foreground leading-relaxed text-sm">
              <p>
                Musicista, educadora e pesquisadora da música brasileira, Clarice tem bacharelado e
                mestrado em música pela UNIRIO e há mais de 20 anos se dedica ao ensino e à difusão do pandeiro.
              </p>
              <p>
                É autora do livro Técnicas e Levadas para Pandeiro Brasileiro, tem um CD solo e quatro CDs
                gravados com o grupo Choro na Feira. Fundou e rege a orquestra de pandeiros Tum Tá Que Tá,
                e é referência no instrumento no Brasil e no exterior.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
